export const META_INFO = {
  description:
    "Simple, effective software for facilitating engaging team retrospectives. Gain insights into your team's needs.",
  primaryData: null,
  secondaryData: null,
}
